import { Controller } from "@hotwired/stimulus"
import Dropzone from "dropzone"

Dropzone.autoDiscover = false

export default class extends Controller {
  static targets = ["dropzone", "nameField", "nameInput", "uploadButton"]
  static values = {
    uploadPath: String,
    maxFileSize: Number
  }

  connect() {
    // Turbo can restore this frame with a Dropzone still bound to the element
    if (this.dropzoneTarget.dropzone) this.dropzoneTarget.dropzone.destroy()

    this.dropzone = new Dropzone(this.dropzoneTarget, {
      url: this.uploadPathValue,
      timeout: 90000,
      parallelUploads: 1,
      maxFiles: 1,
      acceptedFiles: "application/pdf",
      maxFilesize: this.maxFileSizeValue,
      autoProcessQueue: false,
      headers: { "X-CSRF-Token": this.csrfToken }
    })

    this.dropzone.on("addedfile", (file) => this.fileAdded(file))
    this.dropzone.on("sending", (file, xhr, formData) => {
      formData.append("fileName", this.nameInputTarget.value)
    })
    this.dropzone.on("success", (file, response) => {
      window.location.href = response.url
    })
  }

  disconnect() {
    if (this.dropzone) {
      this.dropzone.destroy()
      this.dropzone = null
    }
  }

  upload() {
    this.dropzone.processQueue()
  }

  // The uploader renders inside the article form, which Enter would otherwise submit
  // without a name, since this input is the form's only implicit-submission blocker.
  preventSubmit(event) {
    event.preventDefault()
  }

  fileAdded(file) {
    this.nameFieldTarget.classList.remove("hidden")
    this.uploadButtonTarget.classList.remove("hidden")
    this.nameInputTarget.value = file.name
    this.nameInputTarget.focus()
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.getAttribute("content")
  }
}
